// extracted by mini-css-extract-plugin
export default {"wrapper":"PerformanceTable_wrapper_RYTqe"};